import { lxoMetricCard, lxoRadius, lxoFont } from "shared/styles/lxoDashboardTokens"

export const homeContainer = ({ breakpoints }) => ({
  margin: "0 auto",
  gap: "12px 16px",
  display: "grid",
  gridTemplateColumns: "repeat(6, 1fr)",
  "@media (max-width:1600px)": {
    gridTemplateColumns: "repeat(3, 1fr)",
  },
  [breakpoints.down("xxl")]: {
    gridTemplateColumns: "repeat(3, 1fr)",
  },
  [breakpoints.down("lg")]: {
    gridTemplateColumns: "repeat(2, 1fr)",
  },
  [breakpoints.down("sm")]: {
    gridTemplateColumns: "1fr",
  },
})

const hexToRgba = (hex, alpha) => {
  const r = parseInt(hex.slice(1, 3), 16)
  const g = parseInt(hex.slice(3, 5), 16)
  const b = parseInt(hex.slice(5, 7), 16)
  return `rgba(${r}, ${g}, ${b}, ${alpha})`
}

export const customCardClasses = (theme, accentColor = "#1576BC") => {
  const { breakpoints } = theme

  const iconGlowColor = hexToRgba(accentColor, 0.22)
  const tintColor = hexToRgba(accentColor, 0.05)

  return {
    customCarWrapperStyle: {
      height: `${lxoMetricCard.height}px !important`,
      minHeight: `${lxoMetricCard.height}px !important`,
      padding: `${lxoMetricCard.paddingY}px ${lxoMetricCard.paddingX}px !important`,
      borderRadius: `${lxoRadius.surface}px !important`,
      background: `linear-gradient(145deg, ${tintColor} 0%, #FFFFFF 42%)`,
      border: "1px solid rgba(226,232,240,.85)",
      boxShadow: "0 1px 2px rgba(15,23,42,.04), 0 4px 14px rgba(15,23,42,.04)",
      position: "relative",
      overflow: "hidden",
      transition: "transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease",
      cursor: "default",
      "&::before": {
        content: '""',
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        height: "3px",
        background: `linear-gradient(90deg, ${accentColor}, ${hexToRgba(accentColor, 0.45)})`,
        borderRadius: `${lxoRadius.surface}px ${lxoRadius.surface}px 0 0`,
      },
      "&:hover": {
        transform: "translateY(-1px)",
        borderColor: hexToRgba(accentColor, 0.28),
        boxShadow: "0 2px 4px rgba(15,23,42,.05), 0 8px 22px rgba(15,23,42,.07)",
      },
      [breakpoints.down("md")]: {
        "&:hover": {
          transform: "none",
        },
      },
    },

    customTitleStyle: {
      color: "#64748B",
      fontWeight: 600,
      textTransform: "uppercase",
      letterSpacing: "0.07em",
      fontSize: `${lxoFont.cardTitle}px !important`,
      lineHeight: 1.15,
      marginBottom: 0,
      minHeight: "unset !important",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
    },

    customTextWrapperStyle: {
      gap: "2px",
      flex: 1,
      maxWidth: "calc(100% - 52px)",
      justifyContent: "center",
      paddingRight: "8px",
      minWidth: 0,
    },

    customMainValueStyle: {
      color: "#0F172A",
      fontSize: `${lxoFont.metric}px !important`,
      fontWeight: 700,
      lineHeight: 1,
      letterSpacing: "-0.03em",
      marginTop: "2px",
    },

    customPercentStyle: {
      fontWeight: 600,
      fontSize: "12px !important",
      padding: 0,
      background: "transparent",
      borderRadius: 0,
      lineHeight: 1.2,
    },

    customTimeStyle: {
      fontSize: "11px !important",
      fontWeight: 500,
      color: "#94A3B8",
      lineHeight: 1.2,
    },

    customIconStyle: {
      position: "absolute",
      top: "10px",
      right: "10px",
      opacity: 0.55,
      "& svg": {
        width: "14px",
        height: "14px",
      },
    },

    customLogoContainerStyle: {
      width: `${lxoMetricCard.iconSize}px !important`,
      height: `${lxoMetricCard.iconSize}px !important`,
      minWidth: `${lxoMetricCard.iconSize}px`,
      borderRadius: `${lxoMetricCard.iconRadius}px !important`,
      background: `linear-gradient(135deg, ${accentColor}, ${hexToRgba(accentColor, 0.82)})`,
      boxShadow: `0 3px 10px ${iconGlowColor}`,
      alignSelf: "center",
      flexShrink: 0,
    },

    customLogoStyle: {
      width: `${lxoMetricCard.logoSize}px !important`,
      height: `${lxoMetricCard.logoSize}px !important`,
      flexBasis: `${lxoMetricCard.logoSize}px !important`,
      filter: "brightness(0) invert(1)",
    },
  }
}
